import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SVG from 'react-inlinesvg';

interface ContinueButtonProps {
  action?: () => any;
  dispatch?: (action: any) => void;
  onClick?: () => void;
  url?: string;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({ action, dispatch, onClick, url }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (action && dispatch) {
      dispatch(action());
    }

    if (url) {
      navigate(url);
    }

    if (onClick) {
      onClick();
    }
  }, [action, dispatch, onClick, url, navigate]);

  return (
    <div role="button" onClick={handleClick} className="continue-button">
      CONTINUE
      <SVG src={require('assets/media/icons/forward_arrow_icon.svg')} />
    </div>
  );
};

export default ContinueButton;
